import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  myControl = new FormControl();
  list = [];
  selected_no = '';

  @Input('search_obj') search_obj: {placeholder:'', class_name:''}; 
  @Input('row_id') row_id: string; 
  @Input('search_value') search_value: string;
  // @Input('placeholder') placeholder: string;
  // @Input('class_name') class_name: string;

  @Output() search_result = new EventEmitter<object>();


  constructor(private utils: Utils, private applicationConstants: ApplicationConstants) { }

  ngOnInit() {
    this.list = [];
  }

  search(event) {
    this.list = [];
    let value = event.srcElement.value;
    this.selected_no = '';
    this.search_result.emit({ 'no':'', 'value':value, 'row_id':this.row_id });

    let obj = {cmd: 'search', table_list: this.search_obj['table_list'], value: value};

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        // console.log(data);
        this.list = data.data['list'];
      });

    // let table_list = this.search_obj['table_list'];
    // let table, condition, field_list, condition2, join_condition, query, obj, result;
    // let queryList = [];

    // table_list.forEach(element => {
    //   table = element.table_name;
    //   condition = '';
    //   field_list = element.field_list;
    //   condition2 = '';
    //   join_condition = '';

    //   field_list.forEach(field => {
    //     if (condition != '')
    //       condition += " OR ";
    //     condition += table + ".`" + field + "` LIKE '%" + value + "%'";
    //   });

    //   if (element.condition != undefined)
    //     condition2 = element.condition;

    //   if (element.join_table != undefined) {
    //     table += ", " + element.join_table;
    //     join_condition = element.join_condition;
    //   }

    //   query = "SELECT * FROM " + table + " WHERE " + element.table_name + ".`status` = '1' AND (" + 
    //     condition + ")" + condition2 + join_condition;
    //   obj = { cmd: 'getList', query: query };
      
    //   queryList.push({ 'obj':obj, 'selected_no':element.selected_no, 'field_list':field_list });
    //   //console.log(query);
     
    // });

    // queryList.forEach(element => {
    //   this.utils.invokeHttp(this.applicationConstants.generalFile, element.obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     result = data.data['list'];
    //     result.forEach(r_element => {
    //       r_element.selected_no = r_element[element.selected_no];
    //       r_element.value = '';
    //       element.field_list.forEach(field => {
    //         if (r_element.value != '')
    //           r_element.value += '-';
    //         r_element.value += r_element[field];
    //       });
    //       this.list.push(r_element);
    //     });
    //   });
    // });
  }

  getSearchValue(event) {
    let value = event.srcElement.value;
    console.log('value: ' + value);
    let selectedNo = '';
    if (value != '') {
      if (this.list.length > 0) {
        for (let index = 0; index < this.list.length && selectedNo == ''; index++) {
          if (this.list[index].value == value)
            selectedNo = this.list[index].selected_no;
        }
        if (selectedNo == '')
          this.search_result.emit({ 'no':'', 'value':value, 'row_id':this.row_id });  
        else if (selectedNo != this.selected_no)
          this.search_result.emit({ 'no':selectedNo, 'value':'', 'row_id':this.row_id });
      }
      else 
        this.search_result.emit({ 'no':'', 'value':value, 'row_id':this.row_id }); 
    }
    else 
      this.search_result.emit({ 'no':'', 'value':value, 'row_id':this.row_id }); 
  }

  // selectValue(event) {
  //   event.srcElement.select();
  // }

  selectOption(selected_no) {
    // console.log(selected_no);
    this.selected_no = selected_no;
    this.search_result.emit({ 'no':selected_no, 'value':'', 'row_id':this.row_id });
  }

}
